import {isGaEnabled} from './ga'
import type {AnalyticsEventName} from './events'

// Thin wrapper around gtag('event', ...) modeled on fe/common/errors/breadcrumb.ts.
// Every callsite checks isGaEnabled() so it's a no-op when consent is missing or VITE_GA_MEASUREMENT_ID is empty.

export const trackEvent = (name: AnalyticsEventName, params?: Record<string, unknown>): void => {
  if (!isGaEnabled()) return
  if (typeof window === 'undefined' || !window.gtag) return
  window.gtag('event', name, params)
}

// Debounced variant — for continuous controls (sliders, drag handles) where we only want
// the final value 500 ms after the user stops interacting. Use a stable dedupKey per control.
const debouncedTimers = new Map<string, number>()

export const trackEventDebounced = (
  dedupKey: string,
  name: AnalyticsEventName,
  params?: Record<string, unknown>,
  delayMs = 500,
): void => {
  if (typeof window === 'undefined') return
  const existing = debouncedTimers.get(dedupKey)
  if (existing !== undefined) window.clearTimeout(existing)
  const handle = window.setTimeout(() => {
    trackEvent(name, params)
    debouncedTimers.delete(dedupKey)
  }, delayMs)
  debouncedTimers.set(dedupKey, handle)
}
